module.exports = __webpack_public_path__ + "static/media/SupplyDrop-Logo-Parachute.78a948d8.svg";